export const DEFAULT_TIMEOUT = 60000;
export const INTERNAL_ERROR_MARKERS = ['RHUMB_GLOBAL_ERROR', 'RHUMB_GLOBAL_ERROR_BOUNDARY'];
export const UNEXPECTED_ROUTE_ERROR = Object.assign(new Error('Unexpected route visited. Please see https://product.hubteam.com/docs/frontend/docs/react-rhumb.html#unexpected-route-tracking for more info.'), {
  // Remove stack trace so this error is not sourced to the
  // rhumb library. If this error is thrown, it is because
  // of a bug in the application rhumb config or sometimes
  // just random page visits.
  stack: undefined
});